// extracted by mini-css-extract-plugin
export var fileUpload = "_fn-1";
export var modalButton = "_fn-0";